module.exports = __webpack_public_path__ + "04_face.36a54bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/04_face.png
// module id = uChh
// module chunks = 0